import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from '@/plugins/Loading';
import './app.scss';
// 引入微信JSSDK
import wx from 'weixin-js-sdk';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, GraphChart, GaugeChart, PieChart, CustomChart, ScatterChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import router from '@/routes/index'; 
import Toast from '@/components/plugins/Toast.vue'
import AIChat from '@/components/AIChat.vue'
import ShareButton from '@/components/ShareButton.vue'
import GlobalDisclaimer from '@/components/GlobalDisclaimer.vue'
import AlgorithmValueNotice from '@/components/AlgorithmValueNotice.vue'
import ReportNavigation from '@/components/ReportNavigation.vue'
import store from './store' // 引入 Vuex
const ToastConstructor = Vue.extend(Toast)
function showToast(msg) {
  const instance = new ToastConstructor({
    propsData:{msg}
  });
  console.log('instance',instance)
  instance.$mount();
  document.body.appendChild(instance.$el)
  return instance.open()
}
Vue.prototype.$showToast = function(msg) {
  return showToast(msg)
}
Vue.component('AIChat', AIChat)
Vue.component('ShareButton', ShareButton)
Vue.component('GlobalDisclaimer', GlobalDisclaimer)
Vue.component('AlgorithmValueNotice', AlgorithmValueNotice)
Vue.config.productionTip = false;
// 启用路由
Vue.use(VueRouter);
// 启用加载插件
Vue.use(Loading);

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  GraphChart,
  GaugeChart,
  PieChart,
  ScatterChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  CustomChart, // 自定义图表  
  LegendComponent,
  DataZoomComponent
]);
// 启用 echarts
Vue.prototype.$echarts = echarts;

// 挂载微信SDK到Vue原型
Vue.prototype.$wx = wx;
// 全局挂载到window对象
window.wx = wx;

// 导入国际化配置
import i18n from '@/i18n'



const AppLayout = {
  data() {
    return { reportNavigationVisible: false };
  },
  render(h) {
    const hideEntryActions = this.$store.getters.isThirdPartyMode || (this.$route.meta && this.$route.meta.hideEntryActions);

    return h('div', {
      class: 'app-container',
      style: {
        '--report-navigation-offset': this.reportNavigationVisible
          ? 'calc(4rem + env(safe-area-inset-top, 0px))' : '0px'
      }
    }, [
      // 可以在这里添加 Header、Sidebar 等全局布局
      h(ReportNavigation, {
        on: { 'visibility-change': value => { this.reportNavigationVisible = value; } }
      }),
      h('keep-alive', { props: { exclude: 'Nutrition,Details' } }, [
        h('router-view', { props: { key: this.$route.path } })
      ]),
      h('GlobalDisclaimer'),
      // 全局组件（如底部导航栏、广告条等）
      !hideEntryActions ? h('ShareButton') : null,
      !hideEntryActions ? h('AIChat') : null
    ])
  }
}
// 启动应用
new Vue({
  // 加载全局路由
  router,
  store, // 挂载到根实例
  i18n, // 挂载国际化实例
  // 直接在页面上渲染路由视图
  // render: h => h('router-view')
  render: h => h(AppLayout)
  // render: h =>
  //   h('keep-alive',{ props: { exclude: 'Nutrition,Details' } }, [
  //     h('router-view', {
  //       props: { key: location.pathname } // 可选，强制刷新
  //     })
  //   ])
}).$mount('#app');
